import { createFileRoute } from "@tanstack/react-router";
import { ReferralsLayout } from "#/features/referrals/components/referrals-layout";

export const Route = createFileRoute("/referrals")({
	ssr: false,
	component: ReferralsLayout,
});
